import { Link } from "react-router-dom";
import { ShieldAlert, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export function AdminGate({ title, children }) {
  const { user } = useAuth();
  if (user?.is_platform_admin) return children;
  return (
    <div className="max-w-2xl mx-auto mt-16 border border-zinc-200 bg-white p-12 text-center" data-testid="admin-gate">
      <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#0B1F33] text-white mb-6">
        <ShieldAlert className="h-6 w-6" strokeWidth={1.8} />
      </div>
      <p className="font-mono-data text-xs uppercase tracking-[0.2em] text-[#B54747]">Restricted</p>
      <h1 className="font-display text-4xl font-light mt-2">{title || "Platform administrators only"}</h1>
      <p className="text-zinc-500 mt-3">
        This area is limited to RetainProof™ platform administrators. Your firm's account does not have access.
      </p>
      <Button asChild className="mt-8 bg-[#0B1F33] text-white rounded-none h-11 px-6 group hover:bg-zinc-800" data-testid="admin-gate-back">
        <Link to="/app">
          Back to dashboard
          <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </Button>
    </div>
  );
}

export default AdminGate;
